import React, { useState, useEffect } from 'react';
import { Select, Checkbox, Space, Divider } from 'antd';
import { trIncludes } from '../../../utils/trText';

const { Option } = Select;

const BankingFilters = ({ filters, onChange, darkMode }) => {
  const [banks, setBanks] = useState([]);
  const [btmBanks, setBtmBanks] = useState([]);

  const { API_BASE_URL: SHARED_API_BASE_URL } = require('../../../utils/config');
  const API_BASE_URL = SHARED_API_BASE_URL;
  useEffect(() => {
    const fetchBanks = async () => {
      const url = `${API_BASE_URL}/atm/query?filters=${encodeURIComponent(JSON.stringify([{"field": "fetch", "value": "banks"}]))}`;
        const response = await fetch(url);
        if (response.ok) {
          const data = await response.json();
          const banksData = data.data || [];
          const formattedBanks = banksData.map(b => ({
            id: b.id, 
            name: b.banka
          }));
          setBanks(formattedBanks);
        } else {
          console.error('Failed to fetch banks');
        }
    };
    fetchBanks();
  }, []);

  const handleIncludedBanksChange = (bankIds) => {
    onChange('includedBanks', bankIds || []);
  };

  const handleExcludedBanksChange = (bankIds) => {
    onChange('excludedBanks', bankIds || []);
  };

  useEffect(() => {
    setBtmBanks(banks);
  }, [banks]);

  const handleBtmAtmOffsiteChange = (bankIds) => {
    onChange('btmAtmOffsite', bankIds || []);
  };

  const handleBtmAtmOnsiteChange = (bankIds) => {
    onChange('btmAtmOnsite', bankIds || []);
  };
  
  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Bulunan Bankalar
        </label>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Bulunan bankaları seçin"
          value={filters.includedBanks}
          onChange={handleIncludedBanksChange}
          allowClear
          showSearch
          filterOption={(input, option) =>
            trIncludes(option.children, input)
          }
          maxTagCount="responsive"
        >
          {banks.map(bank => (
            <Option key={bank.id} value={bank.id}>
              {bank.name}
            </Option>
          ))}
        </Select>
        {filters.includedBanks && filters.includedBanks.length > 0 && (
          <div style={{ 
            fontSize: 10, 
            color: darkMode ? '#999' : '#666', 
            marginTop: 2 
          }}>
            {filters.includedBanks.length} banka seçildi
          </div>
        )}
      </div>

      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Bulunmayan Bankalar
        </label>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Bulunmayan bankaları seçin"
          value={filters.excludedBanks}
          onChange={handleExcludedBanksChange}
          allowClear
          showSearch
          filterOption={(input, option) =>
            trIncludes(option.children, input)
          }
          maxTagCount="responsive"
        >
          {banks.map(bank => (
            <Option key={bank.id} value={bank.id}>
              {bank.name}
            </Option>
          ))}
        </Select>
        {filters.excludedBanks && filters.excludedBanks.length > 0 && (
          <div style={{ 
            fontSize: 10, 
            color: darkMode ? '#999' : '#666', 
            marginTop: 2 
          }}>
            {filters.excludedBanks.length} banka hariç tutulacak
          </div>
        )}
      </div>

      <Divider style={{ margin: '8px 0' }} />

      <div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ 
            display: 'block', 
            marginBottom: 4, 
            fontSize: 12,
            color: darkMode ? '#ccc' : '#666'
          }}>
            BKM ATM - Offsite
          </label>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Offsite BKM ATM'lerini seçin"
            value={filters.btmAtmOffsite || []}
            onChange={handleBtmAtmOffsiteChange}
            allowClear
            showSearch
            filterOption={(input, option) =>
              trIncludes(option.children, input)
            }
            maxTagCount="responsive"
          >
            {btmBanks.map(bank => (
              <Option key={`offsite-${bank.id}`} value={bank.id}>
                {bank.name}
              </Option>
            ))}
          </Select>
          {filters.btmAtmOffsite && filters.btmAtmOffsite.length > 0 && (
            <div style={{ 
              fontSize: 10, 
              color: darkMode ? '#999' : '#666', 
              marginTop: 2 
            }}>
              {filters.btmAtmOffsite.length} banka seçildi (Offsite)
            </div>
          )}
        </div>

        <div>
          <label style={{ 
            display: 'block', 
            marginBottom: 4, 
            fontSize: 12,
            color: darkMode ? '#ccc' : '#666'
          }}>
            BKM ATM - Onsite
          </label>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Onsite BKM ATM'lerini seçin"
            value={filters.btmAtmOnsite || []}
            onChange={handleBtmAtmOnsiteChange}
            allowClear
            showSearch
            filterOption={(input, option) =>
              trIncludes(option.children, input)
            }
            maxTagCount="responsive"
          >
            {btmBanks.map(bank => (
              <Option key={`onsite-${bank.id}`} value={bank.id}>
                {bank.name}
              </Option>
            ))}
          </Select>
          {filters.btmAtmOnsite && filters.btmAtmOnsite.length > 0 && (
            <div style={{ 
              fontSize: 10, 
              color: darkMode ? '#999' : '#666', 
              marginTop: 2 
            }}>
              {filters.btmAtmOnsite.length} banka seçildi (Onsite)
            </div>
          )}
        </div>
      </div>

      {filters.includedBanks && filters.excludedBanks && 
       filters.includedBanks.length > 0 && filters.excludedBanks.length > 0 && (
        <div style={{
          padding: '8px',
          backgroundColor: darkMode ? '#3a3a3a' : '#fff7e6',
          border: `1px solid ${darkMode ? '#d48806' : '#ffd591'}`,
          borderRadius: '4px',
          fontSize: '11px',
          color: darkMode ? '#ffec3d' : '#d48806'
        }}>
          ⚠️ Hem dahil hem hariç filtresi seçildi. Dahil filtresi öncelikli olacaktır.
        </div>
      )}
    </Space>
  );
};

export default BankingFilters;
